<template>
    <div>
        <!-- <img
            src="/assets/images/weekend_ft.png"
            class="img-fluid"
            alt="Baner Black Weekend"
            v-if="vehiculoData.precio_feria != vehiculoData.precio_publicacion"
        /> -->
        <section class="listing-detail bg-dark">
            <div class="container">
                <div class="row">
                    <div
                        class="col-md-12 mb-3"
                        v-if="
                            modulo === 'consignacion' &&
                                info_vehiculo.estado_principal !=
                                    'ficha_inventario'
                        "
                    >
                        <div class="alert alert-danger" role="alert">
                            <h3 class="text-center">
                                Vehículo No disponible en Nuestro Inventario
                            </h3>
                        </div>
                    </div>
                    <div class="col-xl-7 col-md-12">
                        <listaImagenes :fotos="fotos" />
                    </div>
                    <aside class="col-xl-5 col-md-12">
                        <div class="widget_heading text-uppercase">
                            <h2 class="mt2 mb-0 text-white">
                                {{ vehiculoData.marca }}
                                {{ vehiculoData.linea }}
                            </h2>
                            <h6 class="text-white" id="title-limit">
                                {{ vehiculoData.modelo }} •
                                {{ vehiculoData.version }}
                            </h6>

                            <!-- <h5 class="grey-text mt-2">
                                {{ vehiculoData.modelo }} •
                                {{ vehiculoData.kilometraje | formatNumber }}
                                km •
                                {{
                                    get_tipo_caja(
                                        vehiculoData.meta_keys.tipo_caja
                                    )
                                }}
                                •
                                {{
                                    get_combustible(
                                        vehiculoData.meta_keys.combustible
                                    )
                                }}
                                 <i class="fa fa-map-marker"></i>
                                {{ clienteData.ubicacion_name }}
                            </h5> -->
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <h3
                                    class="price_info"
                                    v-if="
                                        !vehiculoData.precio_feria ||
                                            vehiculoData.precio_feria == 0 ||
                                            vehiculoData.precio_feria ==
                                                vehiculoData.precio_publicacion
                                    "
                                >
                                    ${{
                                        vehiculoData.precio_publicacion
                                            | formatNumber
                                    }}
                                </h3>
                                <div v-else>
                                    <h3 class="price_info mb-0">
                                        <small class="text-white">Ahora</small>
                                        ${{
                                            vehiculoData.precio_feria
                                                | formatNumber
                                        }}
                                    </h3>
                                    <h3 class="price_tachado mb-0">
                                        Antes ${{
                                            vehiculoData.precio_publicacion
                                                | formatNumber
                                        }}
                                    </h3>
                                </div>
                                <p class="rgt_price">
                                    * Precio de venta no incluye traspaso
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div
                                class="col-md-12 col-12"
                                v-if="
                                    modulo === 'consignacion' &&
                                        info_vehiculo.estado_principal ===
                                            'ficha_inventario'
                                "
                            >
                                <div class="row">
                                    <div class="col-md-12 mb-2">
                                        <b-button
                                            variant="success"
                                            class="btn-whatsapp"
                                            block
                                            @click="redirectTestDrive"
                                        >
                                            <i class="fa fa-whatsapp"></i>
                                            Contactar Asesor
                                        </b-button>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <b-button
                                            variant="dark"
                                            class="text-uppercase mb-2"
                                            block
                                            @click="redirectShare"
                                        >
                                            <i class="fa fa-share-alt"></i>
                                            Compartir
                                        </b-button>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <b-button
                                            variant="danger"
                                            class="text-uppercase mb-2"
                                            block
                                            @click="redirectDownloadPdf"
                                        >
                                            <i class="fa fa-download"></i> Ficha
                                            Técnica
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-md-12 col-12"
                                v-if="modulo === 'oferta'"
                            >
                                <ofertarButton :id="id" />
                            </div>
                            <div class="col-md-4 col-sm-12 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-calendar"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{ vehiculoData.modelo }}
                                    </h5>
                                    <small class="text-danger">Modelo</small>
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-12 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-road"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{
                                            vehiculoData.kilometraje
                                                | formatNumber
                                        }}
                                    </h5>
                                    <small class="text-danger"
                                        >Kilometros</small
                                    >
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-12 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-cog"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{
                                            get_tipo_caja(
                                                vehiculoData.meta_keys.tipo_caja
                                            )
                                        }}
                                    </h5>
                                    <small class="text-danger">Caja</small>
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-12 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-bolt"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{
                                            get_combustible(
                                                vehiculoData.meta_keys
                                                    .combustible
                                            )
                                        }}
                                    </h5>
                                    <small class="text-danger"
                                        >Combustible</small
                                    >
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-12 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-tachometer"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{
                                            vehiculoData.meta_keys.clindraje
                                                | formatNumber
                                        }}
                                        cc
                                    </h5>
                                    <small class="text-danger">Motor</small>
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-12 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-user-plus"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{ vehiculoData.meta_keys.capacidad }}
                                    </h5>
                                    <small class="text-danger">Pasajeros</small>
                                </b-card>
                            </div>
                            <div
                                class="col-md-12 col-12 mt-4 mb-2"
                                v-if="
                                    modulo === 'consignacion' &&
                                        info_vehiculo.estado_principal ===
                                            'ficha_inventario'
                                "
                            >
                                <b-card>
                                    <b-row class="justify-content-md-center">
                                        <b-col class="text-center">
                                            <a href="#consignar">
                                                <h2 class="mb-0 text-danger">
                                                    <i
                                                        class="fa fa-exchange"
                                                        aria-hidden="true"
                                                    ></i>
                                                </h2>
                                                <small class="text-muted"
                                                    >Permuta</small
                                                >
                                            </a>
                                        </b-col>
                                        <b-col class="text-center">
                                            <a
                                                v-if="
                                                    vehiculoData.modelo >=
                                                        2011 &&
                                                        vehiculoData.precio_publicacion >=
                                                            35000000
                                                "
                                                @click="sendFinanciar"
                                            >
                                                <h2 class="mb-0 text-danger">
                                                    <i
                                                        class="fa fa-credit-card-alt"
                                                        aria-hidden="true"
                                                    ></i>
                                                </h2>
                                                <small class="text-muted"
                                                    >Financiación</small
                                                >
                                            </a>
                                            <div v-else>
                                                <h2 class="mb-0 text-muted">
                                                    <i
                                                        class="fa fa-credit-card-alt"
                                                        aria-hidden="true"
                                                    ></i>
                                                </h2>
                                                <small class="text-muted"
                                                    >N/A Financiación</small
                                                >
                                            </div>
                                        </b-col>
                                        <b-col
                                            class="text-center"
                                            v-if="documentosData != ''"
                                        >
                                            <a
                                                target="_blank"
                                                :href="
                                                    'https://brokcars-assets.s3.us-east-2.amazonaws.com/' +
                                                        documentosData
                                                "
                                            >
                                                <h2 class="mb-0 text-danger">
                                                    <i
                                                        class="fa fa-shield"
                                                        aria-hidden="true"
                                                    ></i>
                                                </h2>
                                                <small class="text-muted"
                                                    >Peritado</small
                                                >
                                            </a>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </div>
                        </div>
                    </aside>
                    <div class="w-100"></div>
                    <div class="col-md-12">
                        <button
                            class="btn btn-sm mb-2"
                            id="btn-video-camera"
                            type="button"
                            data-toggle="collapse"
                            data-target="#video-coll"
                            aria-expanded="false"
                            aria-controls="video-coll"
                            v-if="video_link !== null"
                        >
                            <i
                                class="fa fa-video-camera"
                                aria-hidden="true"
                            ></i>
                            Ver video
                        </button>
                        <div class="collapse" id="video-coll">
                            <div class="card">
                                <div class="video_wrap">
                                    <div class="video-box">
                                        <iframe
                                            :src="video_link"
                                            width="800"
                                            height="640"
                                            frameborder="0"
                                            scrolling="no"
                                        ></iframe>
                                        <!--  <iframe
                                            class="mfp-iframe"
                                            :src="video_link"
                                            allowfullscreen
                                        ></iframe> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="listing_more_info p-0 mt-2">
                            <tabListingContainer />
                        </div>
                    </div>
                    <!-- <div
                        class="col-md-12"
                        id="credito"
                        v-if="vehiculoData.modelo >= 2011"
                    >
                        <b-card-group deck>
                            <b-card>
                                <financiacionForm />
                            </b-card>
                            <b-card>
                                <calculadoraForm />
                            </b-card>
                        </b-card-group>
                    </div> -->
                </div>
            </div>
        </section>
        <section class="section-padding gray-bg" id="consignar">
            <div class="container">
                <div class="section-header">
                    <h2>
                        Permuta o Vende
                        <span>Tu Vehículo Usado</span>
                    </h2>
                    <h3>
                        <span>
                            Nos encargamos de la venta de tu vehículo desde el
                            principio hasta el final, maximizando el valor
                            comercial del vehículo, garantizando el pago y el
                            traspaso.
                        </span>
                    </h3>
                    <div class="row">
                        <div class="col-md-8 mt-5">
                            <h4>
                                <span>
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                    Diligencia los datos de tu vehículo en unos
                                    simples clics.
                                </span>
                                <hr />
                                <span>
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                    Agenda una inspección a domicilio o en
                                    nuestra sede.
                                </span>
                                <hr />
                                <span>
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                    Vende tu vehículo al mejor precio del
                                    mercado.
                                </span>
                            </h4>
                            <b-row>
                                <div class="col-md-6 text-center ">
                                    <div class="form-group">
                                        <a
                                            href="/vender"
                                            class="btn btn-block text-uppercase mt-5"
                                        >
                                            Cotiza tu vehículo
                                            <span class="angle_arrow"
                                                ><i
                                                    class="fa fa-angle-right"
                                                    aria-hidden="true"
                                                ></i
                                            ></span>
                                        </a>
                                    </div>
                                </div>
                            </b-row>
                        </div>
                        <div class="col-md-4">
                            <div class="row mt-3">
                                <div class="col-md-12 text-center ">
                                    <img
                                        src="/assets/images/slider/carros.png"
                                        alt="image"
                                        class="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="listing-detail">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <comentariosContainer :id="id" />
                    </div>
                </div>
            </div>
        </section>
        <modalReserva />
        <modalCredito />
    </div>
</template>

<script>
import linksRedesSociales from "./frontLinkRedesSociales";
import listaImagenes from "./frontListaImagenes";
import tabListingContainer from "./tabs/tabListingContainer";
import financiacionForm from "./frontFormFinanciacion";
import contactoAsesorForm from "./frontFormContactoAsesor";
import calculadoraForm from "./frontFormCalculadora";
import formComentario from "./frontFormComentario";
import listaInventario from "../comprar/frontInventario";
import modalReserva from "./modals/modalReserva";
import modalCredito from "./modals/modalCredito";
import ofertarButton from "../detalleVehiculoRetoma/frontOfertarButton";
import { mapFields } from "vuex-map-fields";
import comentariosContainer from "components/comentarios/comentariosContainer";
export default {
    props: {
        datos: Object,
        id: String,
        modulo: String
    },
    components: {
        linksRedesSociales,
        tabListingContainer,
        listaImagenes,
        financiacionForm,
        contactoAsesorForm,
        calculadoraForm,
        formComentario,
        listaInventario,
        modalReserva,
        modalCredito,
        comentariosContainer,
        ofertarButton
    },
    created() {
        this.info_vehiculo = {
            ...this.info_vehiculo,
            id_reporte: this.id,
            cliente: { ...this.datos.vehiculo.cliente },
            asesor: { ...this.datos.vehiculo.asesor },
            vehiculo: this.datos.vehiculo.vehiculo,
            documentos: this.datos.vehiculo.peritaje,
            estado_principal: this.datos.vehiculo.estado_principal
        };
        this.fotos = {
            ...this.fotos,
            ...this.datos.vehiculo.fotos
        };
        this.tabs = {
            ...this.tabs,
            ficha_tecnica: this.datos.vehiculo.proceso.inspeccion_legal,
            accesorios: this.datos.vehiculo.accesorios,
            inspeccion: this.datos.vehiculo.inspeccion
        };
        this.vr_retoma = this.datos.vehiculo.vr_retoma;
        this.vehiculoSimilares = this.datos.vehiculoSimilares;
        this.comentarios = this.datos.vehiculo.comentarios;
        this.video_link = this.datos.vehiculo.proceso.mercadeo.link_youtube;
    },
    computed: {
        ...mapFields("fichaTecnica", [
            "vehiculo.info_vehiculo",
            "vehiculo.vr_retoma",
            "vehiculo.tabs",
            "vehiculo.fotos",
            "vehiculoSimilares",
            "comentarios",
            "video_link"
        ]),
        vehiculoData() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .vehiculo;
        },
        documentosData() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .documentos;
        },
        precioData() {
            return this.$store.state.fichaTecnica.vehiculo.vr_retoma;
        },
        clienteData() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .cliente;
        }
    },
    methods: {
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Tiptronic";
                    break;
            }
        },
        redirectTestDrive() {
            const vehiculo = this.vehiculoData;
            const marca = vehiculo.marca || "";
            const linea = vehiculo.linea || "";
            const version = vehiculo.version || "";
            const modelo = vehiculo.modelo || "";
            const baseUrl = window.location.origin;
            const urlFicha = `${baseUrl}/ficha_tecnica/${this.id}`;

            const mensaje = `Hola, quiero AGENDAR UNA CITA\n  *${marca} ${linea} ${version} ${modelo}*.\nEste es el link de la publicación:\n  ${urlFicha}`;
            const numero = "573188274142";
            const mensajeCodificado = encodeURIComponent(mensaje);
            const urlWhatsapp = `https://wa.me/${numero}?text=${mensajeCodificado}`;

            window.open(urlWhatsapp, "_blank");

            // window.location.href = "/test_drive?step=1&ficha_tecnica=" + this.id;
            // window.location.href = "/test_drive/" + this.id;
        },
        redirectShare() {
            const infoGeneral =
                this.datos.vehiculo.proceso.inspeccion_legal || {};
            const infoTransito =
                this.datos.vehiculo.proceso.inspeccion_legal.vehiculo
                    .transito || {};
            const vehiculo = this.vehiculoData || {};
            const tipoVehiculo = vehiculo.tipo_vehiculo || "";
            const marca = vehiculo.marca || "";
            const linea = vehiculo.linea || "";
            const version = vehiculo.version || "";
            const modelo = vehiculo.modelo || "";
            const kilometraje = vehiculo.kilometraje || "";
            const color = vehiculo.color || "";
            const cilindraje = vehiculo.meta_keys?.clindraje || "";
            const caja = vehiculo.meta_keys?.tipo_caja || "";
            const combustible = vehiculo.meta_keys?.combustible || "";
            const pasajeros = vehiculo.meta_keys?.capacidad || "";
            const puertas = vehiculo.meta_keys?.puertas || "";
            const transmision = vehiculo.meta_keys?.transmision || "";
            const potencia = vehiculo.meta_keys?.potencia || "";
            const placa = infoGeneral.vehiculo.placa
                ? infoGeneral.vehiculo.placa.slice(-1)
                : "";
            const estadoSoat = infoGeneral.vehiculo?.estado_soat || "";
            const estadoTecnicomecanica =
                infoGeneral.vehiculo?.estado_tecnicomecanica || "";
            const transito = infoTransito.ciudad || "-";
            const carroceria = infoGeneral.vehiculo.carroceria || "";
            const unicodueno = infoGeneral.vehiculo.unico_dueno || "";
            const precio = vehiculo.precio_publicacion
                ? new Intl.NumberFormat("es-CO").format(
                      vehiculo.precio_publicacion
                  )
                : "";
            console.log("🏁*¡Nissan X-Trail!*");

            const baseUrl = window.location.origin;
            const urlFicha = `${baseUrl}/ficha_tecnica/${this.id}`;
            const mensaje = `
            🏁 *¡${marca} ${linea} ${version} ${modelo}!* 

            ✔️ Clase: ${tipoVehiculo}
            ✔️ Modelo: ${modelo}
            ✔️ Kilometraje: ${kilometraje} km
            ✔️ Motor: ${cilindraje} cc
            ✔️ Caja: ${caja}
            ✔️ Combustible: ${combustible}
            ✔️ Color: ${color}
            ✔️ Carrocería: ${carroceria}
            ✔️ Capacidad: ${pasajeros} pasajeros
            ✔️ Puertas: ${puertas}
            ✔️ Tracción: ${transmision}
            ✔️ Potencia: ${potencia} hp
            ✔️ SOAT: ${estadoSoat}
            ✔️ Tecnomecánica: ${estadoTecnicomecanica}
            ✔️ Pico y Placa: ${placa}
            ✔️ Tránsito: ${transito}
            ✔️ Único dueño: ${unicodueno}
            💰 *Precio: $${precio}*

            🔁 Recibimos tu vehículo o moto en parte de pago.  
            💳 ¿Necesitas crédito? En Redautos te ofrecemos opciones de financiación.  
            📆 ¡Escríbeme para *AGENDAR TU CITA*!

🔗 Más info: ${urlFicha}`.trim();

            const mensajeCodificado = encodeURIComponent(mensaje);
            const urlWhatsapp = `https://api.whatsapp.com/send?text=${mensajeCodificado}`;
            window.open(urlWhatsapp, "_blank");
        },
        redirectDownloadPdf() {
            const urlFicha = `/ficha_inspeccion/download/${this.id}`;
            window.location.href = urlFicha;
        },
        sendFinanciar() {
            window.location.href = "/financiar?step=1&ficha_tecnica=" + this.id;
        }
    }
};
</script>

<style lang="scss">
.listing-detail {
    padding: 40px 0;
}

.widget_heading {
    margin-bottom: 10px;
}
h3.price_info {
    color: #fff;
    font-weight: 800;
    margin-bottom: auto;
    text-shadow: 1px 0px #ffffff;
    font-size: 45px;
}
h3.price_tachado {
    color: #ff0000;
    font-weight: 800;
    margin-bottom: 0;
    font-size: 32px;
    text-decoration: line-through;
}
p.rgt_price {
    font-size: 18px;
    color: #dad9d9;
    text-decoration-line: overline;
}
h6.grey-text {
    margin-bottom: auto;
    color: #545454;
    font-weight: 500;
}
.slider.slider-horizontal {
    width: 300px;
    height: 20px;
}
button.btn-dark {
    background: #000000;
    border: 1px solid #9e9e9e;
}

.sidebar_widget {
    border: 1px solid #e6e6e6;
    margin: 0 auto 40px;
    padding: 15px 15px 0px;
    position: relative;
}

h5.text-sidebar {
    text-align: center;
    margin-bottom: 0px;
    font-size: 18px;
}
h6#title-limit {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.video_wrap {
    margin: 0px !important;
}
.slick-slide img {
    max-width: 100%;
    width: 100%;
}
i#icon-fa {
    color: #c0c0c0;
    font-size: 36px;
    margin: 0px;
}
button#btn-video-camera {
    background: #eeeeee;
    color: #555;
    text-transform: uppercase;
    font-weight: 600;
}
.btn-whatsapp {
    background-color: #198f15 !important;
    text-transform: uppercase !important;
    margin: 5px 0 5px 0;
}
span.tachado {
    text-decoration: line-through;
    font-size: 16px;
    color: #ffffff;
}
</style>
